import SectionHeading from "../../../components/SectionHeading";
import {
  HomeDemo5Feature1,
  HomeDemo5Feature2,
  HomeDemo5Feature3,
  HomeDemo5Feature4,
  HomeDemo5Feature5,
  HomeDemo5Feature6,
  HomeDemo5Feature7,
  HomeDemo5Feature8,
} from "../../../utils/allImgs";
import Service from "./Service";
import { useTranslation } from "react-i18next";

const OurServices = () => {
  const { t } = useTranslation();

  const Services = [
    {
      img: HomeDemo5Feature1,
      title: t('serviceTitle1'),
      info: t('serviceBody1'),
    },
    {
      img: HomeDemo5Feature2,
      title: t('serviceTitle2'),
      info: t('serviceBody2'),
    },
    {
      img: HomeDemo5Feature3,
      title: t('serviceTitle3'),
      info: t('serviceBody3'),
    },
    {
      img: HomeDemo5Feature4,
      title: t('serviceTitle4'),
      info: t('serviceBody4'),
    },
    {
      img: HomeDemo5Feature5,
      title: t('serviceTitle5'),
      info: t('serviceBody5'),
    },
    {
      img: HomeDemo5Feature6,
      title: t('serviceTitle6'),
      info: t('serviceBody6'),
    },
    {
      img: HomeDemo5Feature7,
      title: t('serviceTitle7'),
      info: t('serviceBody7'),
    },
    {
      img: HomeDemo5Feature8,
      title: t('serviceTitle8'),
      info: t('serviceBody8'),
    },
  ];

  return (
    <section
      className="our_services_area section-padding-100-0 clearfix"
      id="services"
    >
      <div className="container">
        <SectionHeading title={t('whyChoose')} text={t('title4')} />

        <div className="row">
          {Services &&
            Services.map((item, key) => (
              <Service
                key={key}
                img={item.img}
                title={item.title}
                info={item.info}
              />
            ))}
        </div>
      </div>
    </section>
  );
};

export default OurServices;
